import { Navigate } from "react-router-dom";
import Breadcrumb from "@/components/Breadcrumb";
import PageHeading from "@/components/PageHeading/PageHeading";
import usePageTitle from "@/hooks/usePageTitle";
import AppLayout from "@/layouts/AppLayout";
import { useMembershipServicesNavLinks } from "@/pages/people/_membershipServicesNavLinks";
import type { Path } from "@/router";
import { GROUP_EMAIL_PAGE_PATH, useCanAccessGroupEmailPage } from "./access";
import GroupEmailPageForm from "./_components/GroupEmailPageForm";

export default function GroupEmailPage() {
  usePageTitle(GROUP_EMAIL_PAGE_PATH, "People | Group Email");
  const { loaded, canAccess } = useCanAccessGroupEmailPage();
  const navLinks = useMembershipServicesNavLinks();

  if (loaded && !canAccess) {
    return <Navigate to={"/people/membership-services" as Path} replace />;
  }

  if (!loaded) {
    return null;
  }

  return (
    <AppLayout interior bottomBar navLinks={navLinks}>
      <Breadcrumb title="Operations" compactTitle="Group Email" backLink={{ to: "/people/membership-services" }} />
      <PageHeading title="Group Email" compact />
      <div className="mt-6">
        <GroupEmailPageForm />
      </div>
    </AppLayout>
  );
}
